/** @format */

import template from './gb-button.html';
import './gb-button.scss';

export const GbButtonComponent = {
    template,
    transclude: true,
    bindings: {
        icon: '@',
    },
    controller: class GbButtonComponent {
        constructor() {
            'ngInject';
        }
    },
};
